import App from '@/models/App'

export default class Ship extends App {
    static get entity() {
        return 'Ships'
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static first() {
        return this.query().withAllRecursive().first()
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            userId: this.attr(''),
            voyageNo: this.attr(0),
            code: this.attr(''),
            currency: this.attr(''),
            imo: this.attr(''),
            country: this.attr(''),
            name: this.attr(''),
            type: this.attr(''),
            shipBuilder: this.attr(''),
            hullNo: this.attr(''),
            maxEngineRpm: this.attr(0),
            maxSpeed: this.attr(0),
            maxLsmgo: this.attr(0),
            maxLsof: this.attr(0),
            maxFreshWater: this.attr(0),
            maxCapacity: this.attr(0),
            limitAccount: this.attr(0),
            usedAccount: this.attr(0),
            recordPeriod: this.attr(0),
        }
    }
    get isInviteUser() {
        return this.limitAccount > this.usedAccount ? true : false
    }
    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/managed/ships`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            find(shipId) {
                return this.get(`/managed/ships/${shipId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'managedShip',
                    baseURL: App.apiURL(),
                })
            },
            create(params) {
                return this.post(`/managed/ships`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'managedShip',
                    baseURL: App.apiURL(),
                })
            },
            update(params) {
                return this.patch(`/managed/ships`, App.patch(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'managedShip',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
